import { render, staticRenderFns } from "./monthly.vue?vue&type=template&id=f852b806&"
import script from "./monthly.vue?vue&type=script&lang=js&"
export * from "./monthly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports